import { Controller } from "@hotwired/stimulus"

// Remembers whether a Bootstrap collapse was left open, so re-rendering the page does not
// reopen something the reader deliberately closed.
//
// The profile screens live in a Turbo frame that is replaced whole on every stage tab,
// team filter, search and save. In-page collapse state does not survive that, and a note
// that springs back open on every click is worse than one that never folded at all - so
// the choice has to outlive the DOM that held it.
//
// A plain JS-written cookie rather than localStorage, because the server reads it while
// rendering: the panel arrives in the right state instead of being closed after paint,
// which would show a flinch on every one of those frame swaps.
export default class extends Controller {
  static targets = ["panel", "caret"]
  static values = {
    cookie: String,
    // A year. The preference is about this reader's habits, not about the data.
    maxAge: { type: Number, default: 31536000 }
  }

  connect() {
    this.updateCaret()
  }

  // Bound to shown/hidden rather than to the click, so the cookie records what Bootstrap
  // actually settled on rather than what the click was aiming at.
  remember() {
    const collapsed = this.#isOpen() ? "0" : "1"
    document.cookie =
      `${this.cookieValue}=${collapsed}; path=/; max-age=${this.maxAgeValue}; samesite=lax`
    this.updateCaret()
  }

  updateCaret() {
    if (!this.hasCaretTarget) return

    const open = this.#isOpen()
    this.caretTarget.classList.toggle("fa-chevron-down", open)
    this.caretTarget.classList.toggle("fa-chevron-right", !open)
  }

  #isOpen() {
    return this.hasPanelTarget && this.panelTarget.classList.contains("show")
  }
}
